var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnionPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "id_svgCanvas",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "5772181568_SVGID_1__focus",
    d: "M6.503,52c-0.752,0-1.486-0.359-1.963-0.959c-0.477-0.602-0.648-1.375-0.473-2.125l8.311-34.99    c0.273-1.128,1.277-1.912,2.439-1.912L57.318,12c0.768,0,1.482,0.348,1.956,0.954c0.471,0.594,0.648,1.391,0.467,2.127    l-8.313,34.995C51.166,51.207,50.168,52,49,52H6.503z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5772181568_SVGID_1__focus",
    className: "stshockcolor",
    style: {
      fill: "#C7441C",
      overflow: "visible"
    },
    "data-st": "fill:#C7441C;;overflow:visible;"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "5772181568_SVGID_2__focus"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5772181568_SVGID_1__focus",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2",
    style: {
      clipPath: "url(#5772181568_SVGID_2__focus)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.043,52c-0.752,0-1.486-0.359-1.963-0.959c-0.477-0.602-0.648-1.375-0.473-2.125l8.311-34.99    c0.273-1.128,1.277-1.912,2.439-1.912L47,12v40H19.043z",
    style: {
      fill: "#5E749B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.043,52c-0.752,0-1.486-0.359-1.963-0.959c-0.477-0.602-0.648-1.375-0.473-2.125l8.311-34.99    c0.273-1.128,1.277-1.912,2.439-1.912L60,12v40H32.043z",
    style: {
      fill: "#67A6A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.698,21h39.637l-2.138,9H12.56L14.698,21z M27.56,42h21.637l2.138-9H29.698L27.56,42z",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionPay);
export default __webpack_public_path__ + "static/media/union-pay.dff421f003ba4e0158fdc6fce29b911e.svg";
export { ForwardRef as ReactComponent };